import { resolveOrganizedTourDateRange } from "./resolveOrganizedTourDateRange";
import { resolveOrganizedTourDisplaySummary } from "./resolveOrganizedTourDisplaySummary";

/**
 * Build POST /api/lds/organized-tour/info payload from route dealId + selected deal.
 *
 * @param {unknown} selectedResult
 * @param {string|number|null|undefined} routeDealId
 * @param {object|null|undefined} [savedOrder] — שורת LDS (orderByID) כשאין search row / context
 */
export function resolveOrganizedTourInfoRequest(selectedResult, routeDealId, savedOrder = null) {
  const root =
    selectedResult?.fullDeal && typeof selectedResult.fullDeal === "object"
      ? selectedResult.fullDeal
      : selectedResult;
  const tour = root?.tour || selectedResult?.tour || {};
  const orderRoot = savedOrder && typeof savedOrder === "object" ? savedOrder : null;
  const resvHotel = orderRoot?.order_response?.reservation?.hotel;
  const orderSummary = orderRoot
    ? resolveOrganizedTourDisplaySummary(orderRoot, { silent: true })
    : null;

  const dealId = String(
    routeDealId ||
      root?.dealId ||
      root?.ldsDealId ||
      selectedResult?.dealId ||
      orderRoot?.dealid ||
      orderRoot?.dealId ||
      orderRoot?.deal_id ||
      ""
  ).trim();

  const tourName = String(
    orderSummary && orderSummary.tourNameSource !== "fallback"
      ? orderSummary.tourName
      : tour?.tourName ||
          tour?.name ||
          root?.tourName ||
          selectedResult?.tourName ||
          root?.tour?.tourName ||
          orderRoot?.tour_name ||
          orderRoot?.tourName ||
          orderRoot?.outdealname ||
          resvHotel?.hotelName ||
          resvHotel?.hotel_name ||
          ""
  ).trim();

  const supplierId = String(
    root?.supplierDetails?.supplierId ||
      selectedResult?.supplierDetails?.supplierId ||
      tour?.supplierDetails?.supplierId ||
      root?.supplierId ||
      tour?.supplierId ||
      orderRoot?.supplier_id ||
      orderRoot?.supplierId ||
      orderRoot?.supplier_code ||
      orderRoot?.supplierCode ||
      orderRoot?.lds_supplier_code ||
      orderRoot?.supplier?.code ||
      resvHotel?.supplierId ||
      resvHotel?.supplierCode ||
      orderRoot?.order_response?.supplier_id ||
      orderRoot?.order_response?.supplierId ||
      ""
  ).trim();

  const dr = resolveOrganizedTourDateRange(selectedResult ?? root ?? orderRoot ?? {});
  const depDate = String(dr.depRaw || "").trim();
  const retDate = String(dr.retRaw || "").trim();

  /** נדרש לטעינת getOrgTourInfo ברקע (תיאור מפורט) — כל השלושה חובה. */
  const missingFields = [];
  if (!dealId) missingFields.push("dealId");
  if (!tourName) missingFields.push("tourName");
  if (!supplierId) missingFields.push("supplierId");

  return {
    dealId,
    tourName,
    supplierId,
    depDate,
    retDate,
    missingFields,
    canRequest: missingFields.length === 0,
  };
}

export function logOrgTourInfoProfile(event, payload) {
  if (!import.meta.env?.DEV) return;
  const tag = `[ORG_TOUR_INFO_PROFILE_${event}]`;
  console.log(tag, payload);
}
